export const buttonVariants = {
  default: 'inline-flex items-center justify-center rounded-md bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors disabled:opacity-50',
  outline: 'inline-flex items-center justify-center rounded-md border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors disabled:opacity-50',
  ghost: 'inline-flex items-center justify-center rounded-md text-gray-700 font-medium hover:bg-gray-100 transition-colors',
  danger: 'inline-flex items-center justify-center rounded-md bg-red-600 text-white font-medium hover:bg-red-700 transition-colors disabled:opacity-50',
  sizes: {
    sm: 'h-8 px-3 text-sm',
    default: 'h-10 px-4 text-sm',
    lg: 'h-12 px-6 text-base',
  },
} as const;
